
import { useInfiniteQuery } from 'react-query';
import { getOrganisationProjectsApi } from '../../../services/api';


export const useProjectList = ({
  orgId,
  name,
  selectedProjectTypeIds,
  flag,
  sort,
  editorId,
}) => {
  // console.log(orgId, 'orgiddddddddddddddddddddddddddddddd')
  return useInfiniteQuery({
    queryKey: [
      "projects",
      orgId,
      name,
      selectedProjectTypeIds,
      flag,
      sort,
      editorId,
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        organisation_id: orgId,
        page: pageParam,
        status_type_ids: selectedProjectTypeIds,
        ...(name ? { name } : {}),
        ...(flag ? { flag } : {}),
        ...(sort ? { sort } : {}),
        ...(editorId ? { editor_id: editorId } : {}),
      };

      return await getOrganisationProjectsApi(params);
    },
    getNextPageParam: (lastPage, allPages) => {
      // const currentPage = lastPage?.data?.data?.current_page;
      // const totalPages = lastPage?.data?.data?.last_page;

      // if (currentPage < totalPages) {
      //   return currentPage + 1;
      // }
      // return undefined;
      // console.log(lastPage?.data?.data?.next_page, 'lastpageeeeeee useprojectlistt')
      return lastPage?.data?.data?.next_page || undefined;
    },
    initialPageParam: 1,
    keepPreviousData: true,
  });

  
};






